import { Modal, Radio, Select, TimePicker } from "antd";
import React, { useState } from "react";
import { Button, Form, Input, DatePicker } from "antd";
import { IAppointmentsDataType } from "../../../redux/reduxAppointments/appointmentsSlice";
import {
  CONSULTING,
  DAY,
  EVENING,
  FOLLOW_UP,
  NO_CHARGE,
} from "../../CONSTANTS";
import dayjs, { Dayjs } from "dayjs";
import {
  UpdateAppointmentInfo,
  updateAppointment,
  updatePatientBasicInfo,
} from "../../networkCalls";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { responseObject, showToastType } from "../../utils";
var _ = require("lodash");

type EditAppointmentDataType = {
  firstName: string;
  lastName: string;
  startDateTime: Dayjs;
  endDateTime: Dayjs;
  type: string;
};

export function EditAppointmentModal({
  isEditOpen,
  setIsEditOpen,
  appointmentDetails,
}: {
  isEditOpen: boolean;
  setIsEditOpen: any;
  appointmentDetails: IAppointmentsDataType;
}) {
  const [form] = Form.useForm();
  const [formInitialValues, setFormInitialValues] = useState({
    firstName: appointmentDetails.firstName,
    lastName: appointmentDetails.lastName,
    startDateTime: dayjs(appointmentDetails.startDateTime),
    endDateTime: dayjs(appointmentDetails.endDateTime),
    type: appointmentDetails.type,
    consultingSlot: appointmentDetails.consultingSlot,
  });
  function onCancel() {
    console.log(appointmentDetails);
    setIsEditOpen(false);
  }

  async function onFinish(values: EditAppointmentDataType) {
    var patchObject: UpdateAppointmentInfo = {};
    var patchPatientObject: any = {};

    if (
      values.firstName !== undefined &&
      values.firstName !== appointmentDetails.firstName
    ) {
      patchPatientObject["firstName"] = values.firstName;
    }
    if (
      values.lastName !== undefined &&
      values.lastName !== appointmentDetails.lastName
    ) {
      patchPatientObject["lastName"] = values.lastName;
    }
    if (values.type !== undefined && values.type !== appointmentDetails.type) {
      patchObject["type"] = values.type;
    }
    if (
      values.startDateTime !== undefined &&
      values.startDateTime.toISOString() !==
        dayjs(appointmentDetails.startDateTime).toISOString()
    ) {
      patchObject["startDateTime"] = values.startDateTime.toISOString();
      patchObject["endDateTime"] = values.startDateTime
        .add(5, "minute")
        .toISOString();
    }

    if (!_.isEmpty(patchPatientObject)) {
      updatePatientBasicInfo(appointmentDetails.patientId, patchPatientObject)
        .then((patientInfo) => {
          console.log(patientInfo);
          if (!_.isEmpty(patientInfo.id)) {
            toast.success("Patient information was successfully updated");
          }
        })
        .catch((err) => {
          toast.error(
            "There was an error updating Patient information. Please try again"
          );
          console.log(err);
        });
    }
    if (!_.isEmpty(patchObject) && !_.isEmpty(appointmentDetails.id)) {
      updateAppointment(patchObject, appointmentDetails.id)
        .then((appoitments) => {
          toast.success("Appointment Information was successfully updated");
        })
        .catch((err) => {
          toast.error(
            "There was an error updating Appointment information. Please try again"
          );
          console.log(err);
        });
      // const message = updatedAppointmentResponseObject["message"];
      // const status = updatedAppointmentResponseObject["statusCode"];
      // showToastType(message, status);
    }
    setIsEditOpen(false);
  }
  function getLink(firstName: string, lastName: string, patientId: string) {
    return (
      <Link to={`/patient/profile/${patientId}`} target="_blank">
        {firstName} {lastName}
      </Link>
    );
  }
  function onValuesChange(values: IAppointmentsDataType) {
    if (values !== undefined && values.consultingSlot) {
      toast.warn("Make sure you edit the Appointment Times as well");
    }
  }
  return (
    <Modal
      title={`Edit Appointment`}
      open={isEditOpen} //appointmentDetails.firstName == "Yugesha" ? true : false}
      footer={null}
      destroyOnClose={true}
      //   onOk={handleOk}
      onCancel={onCancel}
    >
      <Form
        form={form}
        labelCol={{ span: 8 }}
        onFinish={onFinish}
        initialValues={formInitialValues}
        onValuesChange={onValuesChange}
        preserve={false}
      >
        <h3>
          {getLink(
            appointmentDetails.firstName,
            appointmentDetails.lastName,
            appointmentDetails.patientId
          )}
        </h3>

        <Form.Item label="First Name" name="firstName">
          <Input style={{ width: 200 }} />
        </Form.Item>
        <Form.Item label="Last Name" name="lastName">
          <Input style={{ width: 200 }} />
        </Form.Item>
        <Form.Item
          label="Start Time"
          name="startDateTime"
          // ]}
        >
          <TimePicker
            // defaultValue={defaultStartTime}
            // disabled
            allowClear={false}
            use12Hours
            style={{ marginLeft: 10 }}
            format={"h:mm a"}
          />
        </Form.Item>
        <Form.Item label="Type" name="type">
          <Select
            // defaultValue={appointmentDetails.type}
            style={{ width: 170 }}
            options={[
              { value: CONSULTING, label: "Consulting" },
              { value: FOLLOW_UP, label: "Follow up" },
              { value: NO_CHARGE, label: "No charge" },
            ]}
          />
        </Form.Item>
        <Form.Item name="consultingSlot" label="Consulting Slot">
          <Radio.Group buttonStyle="solid">
            <Radio.Button value={DAY}>DAY</Radio.Button>
            <Radio.Button value={EVENING}>EVENING</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            type="dashed"
            danger
            className="form-button"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            htmlType="submit"
            className="px-4 mx-4"
            style={{ color: "green" }}
          >
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
